import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LeadService } from '../../services/lead.service';
import { PatientService } from '../../services/patient.service';
import { UsersService } from '../../services/users.service';
import { catchError, map, merge, startWith, switchMap, of as observableOf } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { FormControl, NgForm } from '@angular/forms';
import { ModalDismissReasons, NgbDatepickerModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Toast, ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse';
import moment from 'moment';
import { CampaignService } from '../../services/campaign.service';
import { ToolbarComponent } from '../../shared/component/toolbar/toolbar.component';
@Component({
  selector: 'app-lead',
  templateUrl: './lead.component.html',
  styleUrls: ['./lead.component.scss'],
})
export class LeadComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  isMobileView = window.innerWidth <= 1024;
  scrollThumbWidth = 10;
  scrollThumbLeft = 0;
  initialLoad: boolean = true;
  isDataLoading: boolean = false;
  @ViewChild(ToolbarComponent) toolbar!: ToolbarComponent;
  private addPatientModalRef: NgbModalRef | null = null;
  topBarTitle: string = "Leads";
  isLoading = false;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  btnLoading: boolean = false;
  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  currentTab = 'tina';
  formAction = "add";
  closeResult = '';
  isSubmitted: boolean = false;
  displayedColumns: string[] = ["fname", 'lname', "email", "mobile", "date", "followup", "status", "action"];
  exportColumns: string[] = ["fname", "lname", "gender", "email", "mobile", "date", "followup", "status", "platform"];
  dateObject: any = { startDate: "", endDate: "" }
  lead: Lead = new Lead();
  leadFolloup: LeadFollowup = new LeadFollowup();
  @ViewChild("leadForm")
  leadForm!: NgForm;
  @ViewChild("leadFolloupForm")
  leadFolloupForm!: NgForm;
  leadsFollowList: any = [];
  leadChannels: any = [];
  exportArrayData = [];
  LeadArrayData = [];
  temp: any = [];
  subsciberListName: any = "";
  createCampaignFlag: boolean = false;
  patientFeature: boolean = false;
  role: any;
  permissions: any = [];
  modules: any = [];

  // Bulk Import state
  bulkImportModalRef: any;
  usersList: any[] = [];
  bulkAssignedTo: string = '';
  sheetNames: string[] = [];
  columns: string[] = [];
  workbook: XLSX.WorkBook | null = null;
  csvData: any = null;
  selectedSheetName: string = '';
  mappedImportColumns: { [key: string]: string } = {};
  isImporting: boolean = false;

  importSystemFields = [
    { key: 'prefix', label: 'Prefix', required: false },
    { key: 'fname', label: 'First Name', required: true },
    { key: 'lname', label: 'Last Name', required: true },
    { key: 'gender', label: 'Gender', required: false },
    { key: 'age', label: 'Age', required: false },
    { key: 'email', label: 'Email', required: false },
    { key: 'mobile', label: 'Mobile', required: true },
    { key: 'address', label: 'Address', required: false },
    { key: 'city', label: 'City', required: false },
    { key: 'state', label: 'State', required: false },
    { key: 'country', label: 'Country', required: false },
    { key: 'postal_code', label: 'Postal Code', required: false },
    { key: 'date_of_birth', label: 'Date of Birth', required: false },
    { key: 'alternate_phone', label: 'Alternate Phone', required: false },
    { key: 'query', label: 'Primary Query', required: false },
    { key: 'leadStattus', label: 'Lead Type (new/hot/warm/cold)', required: false }
  ];

  // Advanced Filter state
  isFilterApplied: boolean = false;
  leadTypesList: string[] = ['new', 'hot', 'warm', 'cold'];
  sourcesList: string[] = ['tina', 'whatsapp', 'facebook', 'manual'];

  selectedFilterOwners: number[] = [];
  selectedFilterAssigned: number[] = [];
  selectedFilterTypes: string[] = [];
  selectedFilterSources: string[] = [];
  appliedFilters: any = {};

  constructor(private toast: ToastrService, private api: LeadService, private api2: PatientService, private campaignService: CampaignService, private modalService: NgbModal, private localStorage: LocalStorageService, private usersService: UsersService) {

    this.leadChannels = JSON.parse(JSON.stringify(this.localStorage.getLeadChannels()));

    if (this.localStorage.checkFeatures('campaign') == true) {
      this.createCampaignFlag = true;
      this.displayedColumns = ["select", "fname", 'lname', "email", "mobile", "date", "followup", "status", "action"]
    }
  }
  ngAfterViewInit() {
    this.role = this.localStorage.getRole();
    this.permissions = JSON.parse(this.localStorage.getPermissions());
    this.modules = JSON.parse(JSON.stringify(this.localStorage.getFeatureModules()));
    if (this.getFeatureModuleAccess('patients') && this.getAccess('patients')) {
      this.patientFeature = true;
      console.log("patient Feature : ", this.patientFeature);
    }
    this.loadData();
    console.log(this.toolbar);

  }
  ngOnInit(): void {
    // this.checkMobile();
    // window.addEventListener('resize', () => this.checkMobile());
    this.updateScrollThumb();
    setTimeout(() => this.updateScrollThumb(), 100);
  }

  searchFilter(query: any) {
    this.searchQuery.setValue(query);
  }
  ResetDateFilter(event: any) {
    this.dateQuery.setValue("");
  }
  ResetFilter(event: any) {
    this.searchQuery.setValue("");
  }
  clearleadForm() {
    this.lead = new Lead();
  }

  getFeatureModuleAccess(module_name: any) {
    return (this.modules.includes(module_name) ? true : false);
  }

  getAccess(module_name: any) {
    console.log("permissions : ", this.permissions)
    let result = this.permissions.filter((item: any) => {
      return item.module_name == module_name && item.active == true;
    })
    console.log("result : ", result[0])
    return (result[0]) ? true : false;
    //return true;
  }


  // load Initial table data from based on source type
  loadData() {
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(this.dateQuery.valueChanges, this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page).pipe(startWith({}),
        switchMap(() => {
          this.isDataLoading = true;
          console.log(this.dateQuery.value);
          
          if (this.isFilterApplied) {
            let advanceParam: any = {
              where: {
                hospital_id: this.localStorage.getHospitalId(),
                center_id: this.localStorage.getCenterId()
              },
              page: this.paginator.pageIndex + 1,
              limit: this.paginator.pageSize,
              order: { col: 'createdAt', dir: "desc" }
            };
            if (this.searchQuery.value) {
              advanceParam.filter = this.searchQuery.value;
            }
            if (this.dateQuery.value) {
              if (this.dateQuery.value.startDate) advanceParam.date_from = this.dateQuery.value.startDate;
              if (this.dateQuery.value.endDate) advanceParam.date_to = this.dateQuery.value.endDate;
            }
            if (this.selectedFilterOwners && this.selectedFilterOwners.length > 0) {
              advanceParam.user_id = this.selectedFilterOwners;
            }
            if (this.selectedFilterAssigned && this.selectedFilterAssigned.length > 0) {
              advanceParam.assigned_to = this.selectedFilterAssigned;
            }
            if (this.selectedFilterTypes && this.selectedFilterTypes.length > 0) {
              advanceParam.leadStattus = this.selectedFilterTypes;
            }
            if (this.selectedFilterSources && this.selectedFilterSources.length > 0) {
              advanceParam.sources = this.selectedFilterSources;
            } else {
              advanceParam.sources = [this.currentTab];
            }

            return this.api.leadAdvanceFilter(advanceParam)
              .pipe(catchError(() => observableOf(null)));
          } else {
            let param = {
              where: { leadChannel: this.currentTab, hospital_id: this.localStorage.getHospitalId() },
              filter: this.searchQuery.value,
              page: (this.paginator.pageIndex * this.paginator.pageSize),
              limit: this.paginator.pageSize,
              order: { col: 'createdAt', dir: "desc" },
            };
            if (this.dateQuery.value) { param = { ...param, ...this.dateQuery.value } }

            return this.api.getAllData(param)
              .pipe(catchError(() => observableOf(null)));
          }
        }), map((response: any) => {
          this.initialLoad = false;
          if (response === null) {
            return [];
          }

          this.totalRows = response.count;
          return response;
        })
      ).subscribe({
        next: (data) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          this.exportArrayData = data.rows;
          this.LeadArrayData = data.rows;
          this.dataSource = new MatTableDataSource<any>(data.rows);
        },
        error: (e) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          console.error(e);
        },
        complete: () => {
          this.initialLoad = false;
        }
      });
    }
    catch (e) {
      this.initialLoad = false;
      console.error(e);
    }
  }
  dateFilter(event: any) {
    this.dateQuery.setValue(event);
  }
  followUps(content: any, element: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, });
    this.getLead(element.lead_id)
  }
  changeTab(tab: any) {
    this.currentTab = tab;
    this.loadData();
  }
  edit(content: any, object: any) {

    this.formAction = "update";
    this.modalService.open(content, { size: 'xl', scrollable: true });
    this.getLead(object.lead_id)

  }

  getLead(id: any) {
    let param = {
      lead_id: id,
      hospital_id: this.localStorage.getHospitalId()
    }
    this.api.getLead(param).subscribe({
      next: (res) => {
        //console.log(res)
        this.lead = res || {};
        this.leadsFollowList = res.leadsfollowups || [];
      },
      error(err) {

      },
    })
  }
  open(content: any) {
    this.formAction = "add";
    this.clearleadForm();
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;

      },
      (reason) => {

        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  //save Lead Data
  SaveLead(isValid: any) {
    this.isSubmitted = true;

    if (isValid) {
      if (this.formAction == 'add') {
        this.btnLoading = true;
        this.lead.client_id = this.localStorage.getClientId();
        this.lead.hospital_id = this.localStorage.getHospitalId();
        this.lead.leadChannel = "manual";


        this.api.addLeadData(this.lead).subscribe({
          next: (c) => {
            this.modalService.dismissAll()
            this.lead = new Lead();
            this.loadData()
            this.btnLoading = false;
            this.toast.success("Lead Added Successfully", "Success!!")
          },
          error: (e) => {
            this.btnLoading = false;
          },
          complete: () => { }
        })
      }
      else if (this.formAction == 'update') {

        this.btnLoading = true;
        this.api.updateLead(this.lead).subscribe({
          next: (c) => {
            this.modalService.dismissAll()
            this.loadData()
            this.isSubmitted = false
            this.btnLoading = false;
            this.toast.success("Lead Updated Successfully", "Success!!")
            this.lead = new Lead();
          },
          error: (e) => {
            this.btnLoading = false;
            this.isSubmitted = false
          },
          complete: () => { }
        })
      }
      // console.log(this.lead)

    }

  }

  SaveLeadFollowUp(isValid: any) {
    this.isSubmitted = true
    if (isValid) {
      this.btnLoading = true;
      this.leadFolloup.lead_id = this.lead.lead_id;
      this.lead.hospital_id = this.localStorage.getHospitalId();
      this.api.addLeadFollowUp(this.leadFolloup).subscribe({
        next: (c) => {
          this.getLead(this.lead.lead_id)
          this.loadData();
          this.modalService.dismissAll();
          this.btnLoading = false;
          this.isSubmitted = false
          this.toast.success("Lead Followup Added Successfully", "Success!!")
        },
        error: (e) => {
          this.btnLoading = false;
          this.isSubmitted = false
        },
        complete: () => { }
      })
    }

  }
  export(header: any) {
    if (!header || header.length === 0) {
      this.toast.error('Please select at least one column to export');
      return;
    }

    let param: any = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        center_id: this.localStorage.getCenterId()
      },
      order: { col: 'createdAt', dir: "desc" }
    };
    if (this.searchQuery.value) {
      param.filter = this.searchQuery.value;
    }
    if (this.dateQuery.value) {
      if (this.dateQuery.value.startDate) param.date_from = this.dateQuery.value.startDate;
      if (this.dateQuery.value.endDate) param.date_to = this.dateQuery.value.endDate;
    }
    
    if (this.isFilterApplied) {
      if (this.selectedFilterOwners && this.selectedFilterOwners.length > 0) {
        param.user_id = this.selectedFilterOwners;
      }
      if (this.selectedFilterAssigned && this.selectedFilterAssigned.length > 0) {
        param.assigned_to = this.selectedFilterAssigned;
      }
      if (this.selectedFilterTypes && this.selectedFilterTypes.length > 0) {
        param.leadStattus = this.selectedFilterTypes;
      }
      if (this.selectedFilterSources && this.selectedFilterSources.length > 0) {
        param.sources = this.selectedFilterSources;
      } else {
        param.sources = [this.currentTab];
      }
    } else {
      param.sources = [this.currentTab];
    }

    this.toast.info('Exporting data, please wait...', 'Exporting');

    this.api.getAllLeadList(param).subscribe({
      next: (data: any) => {
        if (!data || data.length === 0) {
          this.toast.warning('No data matching the filter criteria to export.');
          return;
        }

        const excelRowData: any = [];
        data.forEach((element: any) => {
          const followupVal = (element.leadsfollowups && element.leadsfollowups.length > 0)
            ? element.leadsfollowups[0].followup_status
            : "N/A";
          
          excelRowData.push({
            0: element.fname,
            1: element.lname,
            2: element.gender,
            3: element.email,
            4: element.mobile,
            5: element.date_of_lead || element.createdAt,
            6: followupVal,
            7: element.leadStattus,
            8: element.leadChannel
          });
        });

        const excelData = [];
        const excelHeader = [];
        for (let i = 0; i < excelRowData.length; i++) {
          const element = excelRowData[i];
          const obj: any = {};
          for (let index = 0; index < header.length; index++) {
            const key = header[index]['key'];
            obj[key] = element[key];
          }
          excelData.push(obj);
        }
        for (let index = 0; index < header.length; index++) {
          const value = header[index]['value'];
          excelHeader.push(value);
        }

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(ws, [excelHeader]);
        XLSX.utils.sheet_add_json(ws, excelData, { origin: 'A2', skipHeader: true });
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        const date = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        XLSX.writeFile(wb, "Leads_data_" + day + "_" + month + "_" + year + "_" + date.getTime() + ".csv");
        this.toast.success('Export completed successfully.', 'Export Success');
      },
      error: (e) => {
        console.error(e);
        this.toast.error('Something went wrong during export.');
      }
    });
  }

  openBulkImport(content: any) {
    this.bulkAssignedTo = '';
    this.sheetNames = [];
    this.columns = [];
    this.workbook = null;
    this.csvData = null;
    this.selectedSheetName = '';
    this.mappedImportColumns = {};
    this.isImporting = false;
    
    this.importSystemFields.forEach(f => {
      this.mappedImportColumns[f.key] = '';
    });

    this.loadUsersForImport();

    this.bulkImportModalRef = this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  loadUsersForImport() {
    const param = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        center_id: this.localStorage.getCenterId()
      },
      page: 0,
      limit: 1000,
      filter: null
    };
    this.usersService.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.usersList = res?.rows || res || [];
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  downloadSampleFormat() {
    const headers = this.importSystemFields.map(f => f.label);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, [headers]);
    XLSX.utils.book_append_sheet(wb, ws, 'Sample Import Format');
    XLSX.writeFile(wb, 'emr_leads_sample_format.xlsx');
  }

  onImportFileUpload(event: any): void {
    const target: HTMLInputElement = event.target;
    if (!target.files || target.files.length !== 1) {
      this.toast.error('Please select a single file');
      return;
    }

    const file: File = target.files[0];
    const fileType = file.name.split('.').pop()?.toLowerCase();

    if (fileType === 'xlsx') {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const bstr: string = e.target.result;
        this.workbook = XLSX.read(bstr, { type: 'binary' });
        this.sheetNames = this.workbook.SheetNames;
        this.selectedSheetName = this.sheetNames[0];
        this.parseSelectedSheet();
      };
      reader.readAsBinaryString(file);
    } else if (fileType === 'csv') {
      Papa.parse(file, {
        complete: (result) => {
          this.csvData = result.data;
          if (this.csvData && this.csvData.length > 0) {
            this.columns = (this.csvData[0] as string[]) || [];
            this.autoMapImportColumns();
          }
        },
        header: false
      });
    } else {
      this.toast.error('Unsupported file type. Please upload CSV or XLSX.');
    }
  }

  parseSelectedSheet(): void {
    if (this.workbook && this.selectedSheetName) {
      const worksheet = this.workbook.Sheets[this.selectedSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      this.columns = (jsonData[0] as string[]) || [];
      this.autoMapImportColumns();
    }
  }

  autoMapImportColumns(): void {
    this.importSystemFields.forEach(field => {
      const match = this.columns.find(col => col && col.toString().trim().toLowerCase() === field.label.toLowerCase());
      if (match) {
        this.mappedImportColumns[field.key] = match;
      } else {
        const keyMatch = this.columns.find(col => col && col.toString().trim().toLowerCase() === field.key.toLowerCase());
        if (keyMatch) {
          this.mappedImportColumns[field.key] = keyMatch;
        } else {
          this.mappedImportColumns[field.key] = '';
        }
      }
    });
  }

  submitBulkImport(): void {
    if (!this.sheetNames.length && !this.csvData) {
      this.toast.error('No file data parsed. Please upload a file.');
      return;
    }

    let rawData: any[] = [];
    if (this.workbook) {
      const sheetName = this.selectedSheetName || this.sheetNames[0];
      const worksheet = this.workbook.Sheets[sheetName];
      if (!worksheet) {
        this.toast.error('Worksheet not found.');
        return;
      }
      rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    } else if (this.csvData) {
      rawData = this.csvData;
    }

    if (rawData.length < 2) {
      this.toast.error('Sheet has no data rows to import.');
      return;
    }

    const headers = rawData[0];
    const rows = rawData.slice(1);

    const validRows = rows.filter(row => {
      return row && row.some((cell: any) => cell !== null && cell !== undefined && cell.toString().trim() !== '');
    });

    if (validRows.length === 0) {
      this.toast.error('No valid data rows found in sheet.');
      return;
    }

    const missingMappings = this.importSystemFields
      .filter(f => f.required && !this.mappedImportColumns[f.key])
      .map(f => f.label);

    if (missingMappings.length > 0) {
      this.toast.error('Missing mappings for required fields: ' + missingMappings.join(', '));
      return;
    }

    const leadsList: any[] = [];
    let rowValidationErrorOccurred = false;

    for (let rIndex = 0; rIndex < validRows.length; rIndex++) {
      const row = validRows[rIndex];
      const leadObj: any = {
        hospital_id: this.localStorage.getHospitalId(),
        client_id: this.localStorage.getClientId(),
        user_id: this.localStorage.getUserId(),
        center_id: this.localStorage.getCenterId(),
        assigned_to: this.bulkAssignedTo || this.localStorage.getUserId(),
        date_of_lead: moment().format('YYYY-MM-DD'),
        time_of_lead: moment().format('HH:mm'),
        leadChannel: this.currentTab || 'manual',
        is_actual_lead: true
      };

      for (const field of this.importSystemFields) {
        const mappedCol = this.mappedImportColumns[field.key];
        if (mappedCol) {
          const colIndex = headers.indexOf(mappedCol);
          if (colIndex > -1) {
            let val = row[colIndex];
            if (val !== undefined && val !== null) {
              val = val.toString().trim();
            }
            leadObj[field.key] = val;
          }
        }
      }

      const rowNum = rIndex + 2;
      if (!leadObj.fname || leadObj.fname === '') {
        this.toast.error(`Row ${rowNum}: First Name is required.`);
        rowValidationErrorOccurred = true;
        break;
      }
      if (!leadObj.lname || leadObj.lname === '') {
        this.toast.error(`Row ${rowNum}: Last Name is required.`);
        rowValidationErrorOccurred = true;
        break;
      }
      if (!leadObj.mobile || leadObj.mobile === '') {
        this.toast.error(`Row ${rowNum}: Mobile is required.`);
        rowValidationErrorOccurred = true;
        break;
      }

      leadsList.push(leadObj);
    }

    if (rowValidationErrorOccurred) {
      return;
    }

    this.isImporting = true;
    this.api.createBulkLead(leadsList).subscribe({
      next: (res: any) => {
        this.isImporting = false;
        this.toast.success('Successfully imported ' + leadsList.length + ' leads.', 'Bulk Import Success');
        this.bulkImportModalRef?.close();
        this.loadData();
      },
      error: (err: any) => {
        this.isImporting = false;
        this.toast.error(err?.error || err?.message || 'Error occurred during import.');
      }
    });
  }

  openAdvancedFilter(content: any) {
    this.loadUsersForImport();
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }

  toggleFilterOwner(userId: number) {
    const idx = this.selectedFilterOwners.indexOf(userId);
    if (idx > -1) {
      this.selectedFilterOwners.splice(idx, 1);
    } else {
      this.selectedFilterOwners.push(userId);
    }
  }

  toggleFilterAssigned(userId: number) {
    const idx = this.selectedFilterAssigned.indexOf(userId);
    if (idx > -1) {
      this.selectedFilterAssigned.splice(idx, 1);
    } else {
      this.selectedFilterAssigned.push(userId);
    }
  }

  toggleFilterType(type: string) {
    const idx = this.selectedFilterTypes.indexOf(type);
    if (idx > -1) {
      this.selectedFilterTypes.splice(idx, 1);
    } else {
      this.selectedFilterTypes.push(type);
    }
  }

  toggleFilterSource(source: string) {
    const idx = this.selectedFilterSources.indexOf(source);
    if (idx > -1) {
      this.selectedFilterSources.splice(idx, 1);
    } else {
      this.selectedFilterSources.push(source);
    }
  }

  applyAdvancedFilters() {
    this.isFilterApplied = true;
    this.paginator.pageIndex = 0;
    this.modalService.dismissAll();
    this.loadData();
  }

  clearAllFilters() {
    this.selectedFilterOwners = [];
    this.selectedFilterAssigned = [];
    this.selectedFilterTypes = [];
    this.selectedFilterSources = [];
    this.isFilterApplied = false;
    this.paginator.pageIndex = 0;
    this.loadData();
  }

  addSubscriberList(isValid: any) {
    this.isSubmitted = true
    if (isValid) {
      this.btnLoading = true;
      let list_number: any = [];
      let list_email: any = [];
      console.log(this.temp)
      const list = this.temp.reduce((res: any, item: any) => {
        if (item.mobile) {
          list_number.push(item.mobile);
        }
        if (item.email) {
          list_email.push(item.email);
        }
        res.push({ lead_id: item.lead_id, hospital_id: item.hospital_id, fname: item.fname, lname: item.lname, name: item.name, mobile: item.mobile, email: item.email });
        return res;
      }, []);
      let params = {
        "subscriber_name": this.subsciberListName,
        "hospital_id": this.localStorage.getHospitalId(),
        "total_subscriber": this.temp.length,
        "subscriber_list": list,
        "subscriber_phones": list_number,
        "subscriber_emails": list_email
      };
      //console.log(params)

      this.campaignService.createSubscriberList(params).subscribe({
        next: (c) => {
          this.modalService.dismissAll();
          this.temp = [];
          this.btnLoading = false;
          this.isSubmitted = false;
          this.toast.success("Subscriber List Added Successfully", "Success!!");
        },
        error: (e) => {
          this.btnLoading = false;
          this.isSubmitted = false
        },
        complete: () => { }
      })
    }
  }

  isAllSelected() {
    return this.dataSource.data.every((item) => item.isSelected);
  }

  isAnySelected() {
    return this.dataSource.data.some((item) => item.isSelected);
  }

  selectOne(event: any, element: any) {
    if (event.target.checked) {
      this.temp.push(this.LeadArrayData.find((lead: any) => lead.lead_id == element.lead_id));
    }
    else {
      this.temp = this.temp.filter(function (obj: any) {
        return obj.lead_id !== element.lead_id;
      })
    }

    if (this.temp.length > 0) {
      this.toolbar.isGroupActive = 'New Group';
    }
    if (this.temp.length <= 0) {
      this.toolbar.isGroupActive = '';
    }
  }

  selectAll(event: any) {

    var checkboxes: any = document.getElementsByClassName('check_input_manual');
    if (event.target.checked) {

      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].type == 'checkbox') {
          //console.log(this.LeadArrayData)
          let leadObject = this.LeadArrayData.find((lead: any) => lead.lead_id == checkboxes[i].value);
          // console.log(leadObject)
          checkboxes[i].checked = true;
          this.temp.push(leadObject)
        }
      }
    }
    else {
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].type == 'checkbox') {
          checkboxes[i].checked = false;
        }
      }
      this.temp = [];
    }

    console.log(this.temp)

    if (this.temp.length > 0) {
      this.toolbar.isGroupActive = 'New Group';
    }
    if (this.temp.length <= 0) {
      this.toolbar.isGroupActive = '';
    }
  }

  openList(content: any) {
    console.log("hello garuav")
    if (this.temp.length < 1) {
      this.toast.error("Please select a record to create the list !");
    }
    else {
      this.formAction = "add";
      this.modalService.open(content, { size: 'md', scrollable: true }).result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;

        },
        (reason) => {

          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
    }
  }

  // Patients
  pateintBtn = false;
  selectedLeads: any = null;
  isPatientExist = false;

  addAsPatient(content: any, object: any) {
    this.selectedLeads = object;
    this.isPatientExist = object?.isPatient || false;
    if (this.isPatientExist) {
      this.toast.success("Existing Patient !");
    }
    else {
      this.addPatientModalRef = this.modalService.open(content, { windowClass: 'modal', scrollable: false, ariaLabelledBy: 'modal-basic-title', centered: true });
    }
  }

  addPatient() {
    this.pateintBtn = true;
    let newPatient = {
      "pId": "N/A",
      "hospital_id": this.localStorage.getHospitalId(),
      "center_id": this.localStorage.getCenterId(),
      "prefix": this.selectedLeads.prefix,
      "fname": this.selectedLeads.fname,
      "lname": this.selectedLeads.lname,
      "name": this.selectedLeads.fname + " " + this.selectedLeads.lname,
      "mobile": this.selectedLeads.mobile ? this.selectedLeads.mobile : ("00" + Date.now().toString().slice(-6) + Math.floor(Math.random() * 100).toString().padStart(2, '0')),
      "email": this.selectedLeads.email || "N/A",
      "source": this.selectedLeads.leadChannel,
      "photo": null,
      "gender": null,
      "age": null,
      "dob": null,
      "blood_group": null,
      "uid_number": null,
      "abha_number": null,
      "alt_contact_number": null,
      "old_patient_record_number": null,
      "insurance_details": null,
      "address": null
    }
    try {
      this.api2.createPatient(newPatient).subscribe({
        next: (res: any) => {
          if (res) {
            console.log("resss : ", res)
            let param = {
              "lead_id": this.selectedLeads.lead_id,
              "isPatient": true
            }
            this.selectedLeads.isPatient = true;
            const data = this.dataSource.data;
            const rowToUpdate = data.find((item) => item.lead_id === this.selectedLeads.lead_id);
            if (rowToUpdate) {
              Object.assign(rowToUpdate, this.selectedLeads); // Update only the changed fields
            }

            // Refresh the table (optional if Angular detects changes automatically)
            this.dataSource.data = data;

            this.api.updateLead(param).subscribe({
              next: (res: any) => {
                console.log("lead res : ", res)
              }
            });
            this.pateintBtn = false;
            this.addPatientModalRef?.close();
            this.toast.success(res);
          }
        },
        error: (e) => {
          this.pateintBtn = false;
          this.addPatientModalRef?.close();
          this.toast.error("Failed !");
        }
      })
    } catch (error) {
      this.pateintBtn = false;
      this.addPatientModalRef?.close();
      this.toast.error("Failed !");
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth <= 1024;
  }

  handleScrollLeft() {
    const container = this.scrollContainer.nativeElement;
    container.scrollBy({ left: -150, behavior: 'smooth' });
    setTimeout(() => this.updateScrollThumb(), 300);
  }

  handleScrollRight() {
    const container = this.scrollContainer.nativeElement;
    container.scrollBy({ left: 150, behavior: 'smooth' });
    setTimeout(() => this.updateScrollThumb(), 300);
  }

  updateScrollThumb() {
    if (!this.scrollContainer) return;

    const container = this.scrollContainer.nativeElement;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;
    const scrollLeft = container.scrollLeft;

    if (scrollWidth > clientWidth) {
      this.scrollThumbWidth = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
      const maxScrollLeft = scrollWidth - clientWidth;
      const scrollPercentage = (scrollLeft / maxScrollLeft) * 100;
      this.scrollThumbLeft = (scrollPercentage * (100 - this.scrollThumbWidth)) / 100;
      this.scrollThumbLeft = Math.max(0, Math.min(100 - this.scrollThumbWidth, this.scrollThumbLeft));
    } else {
      this.scrollThumbWidth = 100;
      this.scrollThumbLeft = 0;
    }
  }



}


export class Lead {
  lead_id!: Number;
  fname: string = "";
  lname: string = "";
  leadsfollowup!: JSON;
  prefix: string = "";
  date_of_lead: String = moment().format("YYYY-MM-DD");
  time_of_lead: String = moment().format("HH:mm");
  gender: string = "";
  age: Number = 0;
  email: string = "";
  mobile: string = "";
  state: string = "";
  country: string = "";
  city: string = "";
  address: string = "";
  query: string = "";
  leadStattus: string = ""
  client_id: string = ""
  hospital_id: Number = 0
  leadChannel: String = ""
}
export class LeadFollowup {
  lead_id!: Number;
  followup_status: string = "";
  feedback: string = "";
  user_query: string = "";
  comment: string = "";
}

